// extracted by mini-css-extract-plugin
module.exports = {"notFound":"blog-not-found_notFound__oqz8m","notFound_title":"blog-not-found_notFound_title__R3I3z","notFound_text":"blog-not-found_notFound_text__d0gWO"};